module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"PDF-LISTEN","select":"Auswahl","export":"Export","archive":"Archiv","support_link":"Support","logout":"Abmeldung"},"en":{"title":"PDF-Lists","select":"Select","export":"Export","archive":"Archive","support_link":"Support","logout":"Logout"}}')
  delete Component.options._Ctor
}
